export const customDownload = (data, filename) => {
  if (!data || data.length === 0) {
    console.error("No data available for CSV export");
    return;
  }

  // Define desired header order, with employeeName first
  const headers = [
    "empid",
    "employeeName",
    "dateOfPayment",
    "month",
    "year",
    "salaryBasic",
    "salaryGross",
    "salaryNet",
    "ExpenseNet",
    "TotalDaysWorked",
    "leavedays",
    "restdays",
    "allowanceFuel",
    "allowanceHouseRent",
    "allowanceMedical",
    "allowanceOther",
    "allowancePhoneBill",
    "allowanceSpecial",
    "allowanceTotal",
    "deductionProvidentFund",
    "deductionTax",
    "deductionOther",
    "deductionTotal",
    "AdvanceAdjust",
    "esicAmount",

    // "id"
  ];
  function formatDate(date) {
    if (!date) return "";
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  }


  const formattedHeaders = headers.map(
    h => h.charAt(0).toUpperCase() + h.slice(1)
  );

  // const csvRows = [
  //   headers.join(","), // header row
  //   ...data.map(row =>
  //     headers.map(field => `"${row[field] ?? ""}"`).join(",") // data rows
  //   )
  // ];

  const csvRows = [
    formattedHeaders.join(","), // Capitalized headers
    ...data.map(row =>
      headers.map(field => {
        let value = row[field] ?? "";
        if (field === "dateOfPayment") {
          value = formatDate(value);
        }
        return `"${value}"`;
      }).join(",")
    )
  ];

  const csvString = csvRows.join("\n");
  const blob = new Blob([csvString], { type: "text/csv" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `${filename}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
